export enum AppointmentStep {
  APPOINTMENT_DETAILS = 'APPOINTMENT_DETAILS',
  PMR_CONSENT = 'PMR_CONSENT',
}

export enum PMRConsentValue {
  YES = 'yes',
  NO = 'no',
  UNKNOWN = 'unknown',
  EMPTY = '',
}

export enum PetParentConsentValue {
  YES = 'yes',
  NO = 'no',
  EMPTY = '',
}
